/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Radio,
  Typography,
  notification,
  Card,
  Select,
  DatePicker,
  Space,
  Tag,
  Button,
  Pagination,
  Table,
  Tooltip,
  Badge,
  Popconfirm,
  Checkbox,
} from "antd";
import {
  EyeFilled,
  WhatsAppOutlined,
  PhoneOutlined,
  MailOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import Search from "antd/es/input/Search";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../../../../components/common/Loader";
import {
  fetchExchangeLeadList,
  fetchLeadDetailsServices,
} from "../../../auth/slice/authSlice";
import NoDataFound from "../../../../components/common/NoDataFound";
import { approveRejectFinalInspectionService } from "../../../../services/master-services";
import ModalComponent from "../../../../components/modals/ModalComponent";
import { leadsInitialState } from "../../../../utills/constant";
import {
  getFilterAreaService,
  getFilterTerritoriesService,
  getLeadOwnerService,
  getLeadService,
  getLeadStagesService,
  getVehicleModelService,
  getLeadExchangeStageService,
  getFileStagesService,
} from "../../../../services/master-services";
import { ddmmyyFormatter, openLeadViewInNewWindow } from "../../../../utills/helpers";
import { API_RESPONSE_CODES } from "../../../../utills/constant";
import dayjs from "dayjs";

const { Title } = Typography;
const { RangePicker } = DatePicker;

const ExchangeLeads = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = useSelector((state) => state?.auth?.isAdmin);
  const roleType = useSelector((state) => state?.auth?.userData?.role);
  const searchParams = new URLSearchParams(location.search);

  const hotKeyId = searchParams.get("key");
  const typeParamId =
    searchParams.get("lead_type") === "10" ? "" : searchParams.get("lead_type");
  const stageParamId = searchParams.get("lead_stage");
  const leadExchangeStageId = searchParams.get("lead_exchange_stage_id");
  const leadOwnerName = searchParams.get("lead_owner_name");
  const exchangeOfficerName = searchParams.get("exchange_officer_name");
  const exchangeStageNameParam =
    searchParams.get("lead_exchange_stage_name") ||
    searchParams.get("exchange_stage_name") ||
    null;
  const userTransferParams = searchParams.get("transfer");
  const areaIdsFromParams = [];
  const leadOwnedFromParams = [];
  for (const [key, value] of searchParams.entries()) {
    if (key.startsWith("area_id[")) areaIdsFromParams.push(value);
    if (key.startsWith("lead_owned[")) leadOwnedFromParams.push(value);
  }
  const areaIdParam = searchParams.get("area_id") || null;
  const leadOwnedParam = searchParams.get("lead_owned") || null;
  const currentMonthParam = searchParams.get("current_month");
  const startDateParam = searchParams.get("start_date");
  const endDateParam = searchParams.get("end_date");
  const needProcurment =
    searchParams.get("need_procured") === `"true"` ? true : false;
  const needEvaluation =
    searchParams.get("need_evaluation") === `"true"` ? true : false;
  const approvalPendingForFinalInspectionParam = searchParams.get(
    "approval_pending_for_final_inspection"
  );
  const isApprovalPendingForFinalInspection =
    approvalPendingForFinalInspectionParam === "1" ||
    approvalPendingForFinalInspectionParam === "true";
  const lastMonthParam = searchParams.get("last_month");
  const isLastMonth = lastMonthParam === "true" || lastMonthParam === '"true"';
  const procuredParam = searchParams.get("procured");
  const isProcured =
    procuredParam === "true" || procuredParam === 1 || procuredParam === "1";

  const exchangeLeadsData = useSelector(
    (state) => state?.auth?.exchangeLeads?.data
  );
  const exchangeLeads = exchangeLeadsData?.list_data;
  const dashboardData = useSelector(
    (state) => state?.auth?.dashboardHomeFilters
  );
  const dashboardRedirectParam = searchParams.get("dashboard_redirect");
  const liveBookingRedirectParam = searchParams.get("live_booking_redirect");
  const liveBookingCategoryParam = searchParams.get("live_booking_category");
  const mtdBookingRedirectParam = searchParams.get("mtd_booking_redirect");
  const modelIdParam = searchParams.get("model_id");
  const areaNameParam = searchParams.get("area_name");
  const isLiveBookingRedirect =
    liveBookingRedirectParam === "true" || liveBookingRedirectParam === "1";
  const isMtdBookingRedirect =
    mtdBookingRedirectParam === "true" || mtdBookingRedirectParam === "1";
  const isDashboardTableRedirect = isLiveBookingRedirect || isMtdBookingRedirect;
  const shouldUseDashboardDateFallback =
    hotKeyId && !isDashboardTableRedirect;
  const showRedirectTags = hotKeyId || isDashboardTableRedirect;
  const modelTypeArrayFromParams = [];
  for (const [key, value] of searchParams.entries()) {
    if (key.startsWith("model_type[")) modelTypeArrayFromParams.push(value);
  }
  const userType = dashboardData?.userId;
  // Format dates to YYYY-MM-DD format
  const formatDateToYYYYMMDD = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";
    return date.toISOString().split("T")[0]; // Returns YYYY-MM-DD format
  };

  const startDateId = formatDateToYYYYMMDD(dashboardData?.startDate);
  const endDateId = formatDateToYYYYMMDD(dashboardData?.endDate);
  const modelType = dashboardData?.modelNo;

  const hasMenuFilter = Boolean(
    leadExchangeStageId || isApprovalPendingForFinalInspection
  );

  const [tagNames, setTagnames] = useState({});
  const [areaData, setAreaData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [ownerData, setOwnerData] = useState([]);
  const [leadsTypeData, setLeadsTypeData] = useState([]);
  const [leadStageData, setLeadStageData] = useState([]);
  const [territoryData, setTerritoryData] = useState([]);
  const [exchangeStages, setExchangeStages] = useState([]);
  const [fileStageData, setFileStageData] = useState([]);
  const [radioData, setRadioData] = useState("all");
  // State for Exchange Stage filter (instead of URL params for user selections)
  const [exchangeStageFilter, setExchangeStageFilter] = useState(undefined);
  const [modalData, setModalData] = useState([]);
  const [filters, setFilters] = useState({
    page: 1,
    per_page: 10,
    search: "",
    procured: isProcured ? true : false,
    evaluation_completed: false,
    lead_stage: stageParamId ? [stageParamId] : [],
    lead_type: typeParamId ? [typeParamId] : [],
    lead_exchange_stage_id: leadExchangeStageId ? leadExchangeStageId : null,
    need_evaluation: needEvaluation ? needEvaluation : false,
    need_procured: needProcurment ? needProcurment : false,
    approval_pending_for_final_inspection: isApprovalPendingForFinalInspection
      ? 1
      : null,
    last_month: isLastMonth ? true : false,
    start_date: startDateParam
      ? startDateParam
      : shouldUseDashboardDateFallback && startDateId
      ? startDateId
      : null,
    end_date: endDateParam
      ? endDateParam
      : shouldUseDashboardDateFallback && endDateId
      ? endDateId
      : null,
    model_type: modelTypeArrayFromParams.length
      ? modelTypeArrayFromParams
      : modelIdParam
      ? [modelIdParam]
      : hotKeyId && modelType
      ? [modelType]
      : [],
    territory_id: [],
    area_id: areaIdsFromParams.length
      ? areaIdsFromParams
      : areaIdParam
      ? [areaIdParam]
      : [],
    lead_owned: leadOwnedFromParams.length
      ? leadOwnedFromParams
      : leadOwnedParam
      ? [leadOwnedParam]
      : [],
    current_month:
      currentMonthParam === "true" || currentMonthParam === "1" ? true : false,
    allocation_status: null,
    file_stage_id: null,
    dashboard_redirect: isDashboardTableRedirect
      ? false
      : hotKeyId &&
        (dashboardRedirectParam === "true" || dashboardRedirectParam === "1")
      ? true
      : hotKeyId &&
        (userType || startDateId || endDateId || modelType) &&
        !userTransferParams
      ? true
      : false,
    live_booking_redirect: isLiveBookingRedirect,
    live_booking_category: liveBookingCategoryParam || "",
    mtd_booking_redirect: isMtdBookingRedirect,
  });

  const [register, setRegister] = useState({
    state_id: 0,
    territory_id: 0,
  });

  const hasExchangeLeadsData = exchangeLeads?.length > 0;
  useEffect(() => {
    getLeadsTypeData();
    getTerritoryData();
    getLeadStagesData();
    getOwnerData();
    getModalData();
    getAreaData();
    getExchangeStagesData();
    getFileStagesData();
  }, []);

  useEffect(() => {
    getLeadStagesData();
  }, [stageParamId]);

  const handleChange = (e) => {
    const value = e.target.value;
    setRadioData(value);
    setFilters((prev) => ({
      ...prev,
      need_evaluation: value === "need_evaluation",
      evaluation_completed: value === "evaluation_completed",
      need_procured: value === "need_procured",
      procured: value === "procured",
      page: 1,
    }));
  };

  useEffect(() => {
    getExchangeLeadListing(filters);
  }, [filters]);

  // Update filters when URL parameters change and reset other filters
  // Watch location.search to detect any URL changes (including navigation to clean URL)
  useEffect(() => {
    // Check if URL has any meaningful params (not just empty search)
    const hasUrlParams = location.search && location.search.length > 0;
    
    // If no URL params (clean URL), reset all filters to defaults
    if (!hasUrlParams) {
      setFilters({
        page: 1,
        per_page: 10,
        search: "",
        procured: false,
        evaluation_completed: false,
        lead_stage: [],
        lead_type: [],
        lead_exchange_stage_id: null,
        need_evaluation: false,
        need_procured: false,
        approval_pending_for_final_inspection: null,
        last_month: false,
        start_date: null,
        end_date: null,
        model_type: [],
        territory_id: [],
        area_id: [],
        lead_owned: [],
        current_month: false,
        allocation_status: null,
        file_stage_id: null,
        dashboard_redirect: false,
        live_booking_redirect: false,
        live_booking_category: "",
        mtd_booking_redirect: false,
      });
      return;
    }

    if (isDashboardTableRedirect) {
      return;
    }

    // Reset filters when URL changes (menu tabs change or navigation with params)
    setFilters((prev) => ({
      ...prev,
      page: 1,
      search: "", // Reset search
      lead_type: typeParamId ? [typeParamId] : [], // Set from URL or reset
      lead_stage: stageParamId ? [stageParamId] : [], // Set from URL or reset
      model_type: modelTypeArrayFromParams.length
        ? modelTypeArrayFromParams
        : modelIdParam
        ? [modelIdParam]
        : hotKeyId && modelType
        ? [modelType]
        : [],
      live_booking_redirect: isLiveBookingRedirect,
      live_booking_category: liveBookingCategoryParam || "",
      mtd_booking_redirect: isMtdBookingRedirect,
      territory_id: [], // Reset territory
      area_id: areaIdsFromParams.length
        ? areaIdsFromParams
        : areaIdParam
        ? [areaIdParam]
        : [], // Set from URL or reset
      lead_owned: leadOwnedFromParams.length
        ? leadOwnedFromParams
        : leadOwnedParam
        ? [leadOwnedParam]
        : [], // Set from URL or reset
      allocation_status: null, // Reset allocation status
      file_stage_id: null, // Reset file stage
      // Set filters from URL params or reset to defaults
      need_evaluation: needEvaluation ? needEvaluation : false,
      need_procured: needProcurment ? needProcurment : false,
      procured: isProcured ? true : false,
      evaluation_completed: false,
      // Keep menu-specific parameters
      lead_exchange_stage_id: leadExchangeStageId ? leadExchangeStageId : null,
      approval_pending_for_final_inspection: isApprovalPendingForFinalInspection
        ? 1
        : null,
      last_month: isLastMonth ? true : false,
      current_month:
        currentMonthParam === "true" || currentMonthParam === "1"
          ? true
          : false,
      start_date: startDateParam
        ? startDateParam
        : shouldUseDashboardDateFallback && startDateId
        ? startDateId
        : null,
      end_date: endDateParam
        ? endDateParam
        : shouldUseDashboardDateFallback && endDateId
        ? endDateId
        : null,
      dashboard_redirect: isDashboardTableRedirect
        ? false
        : hotKeyId &&
          (dashboardRedirectParam === "true" || dashboardRedirectParam === "1")
        ? true
        : hotKeyId &&
          (userType || startDateId || endDateId || modelType) &&
          !userTransferParams
        ? true
        : false,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]); // Watch entire URL search string to detect any changes

  // Get current exchange stage value for dropdown (from URL params for menu/dashboard redirects)
  const getCurrentExchangeStageValue = () => {
    // Only use URL params for menu/dashboard redirects
    if (hasMenuFilter || hotKeyId) {
      const unAllocatedParam = searchParams.get("un_allocated");
      const isUnAllocated =
        unAllocatedParam === "1" || unAllocatedParam === "true";
      if (isUnAllocated) return "un_allocated";
      if (isApprovalPendingForFinalInspection) return "awaiting_inspection";
      if (leadExchangeStageId) {
        if (isLastMonth && leadExchangeStageId === "1")
          return "pending_eval_prev_month";
        if (leadExchangeStageId === "1") return "pending_eval_current_month";
        return `stage_${leadExchangeStageId}`;
      }
    }
    return undefined;
  };

  // Update exchange stage filter state when URL params change (for menu/dashboard redirects)
  useEffect(() => {
    if (hasMenuFilter || hotKeyId) {
      const value = getCurrentExchangeStageValue();
      setExchangeStageFilter(value);
    } else {
      // Reset to undefined when not from menu/dashboard
      setExchangeStageFilter(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]); // Watch entire URL search string to detect any changes

  useEffect(() => {
    if (hotKeyId && typeParamId) {
      const lead_type =
        typeParamId === "10"
          ? "Live"
          : leadsTypeData?.filter((ele) => ele.id === +typeParamId)?.at(0)
              ?.name;
      setTagnames((state) => ({
        ...state,
        "Lead Type": lead_type,
      }));
    }
    if (hotKeyId && stageParamId) {
      const stageIdNum = Number(stageParamId);
      const matchedStage = leadStageData?.find(
        (ele) =>
          String(ele.id) ===
          String(!Number.isNaN(stageIdNum) ? stageIdNum : stageParamId)
      );
      const val = matchedStage?.name || "";
      if (val) {
        setTagnames((state) => ({
          ...state,
          "Lead Stage": val,
        }));
      }
    }
    if (hotKeyId && needProcurment) {
      setTagnames((state) => ({
        ...state,
        Procurement: "Pending",
      }));
    }
    if (hotKeyId && needEvaluation) {
      setTagnames((state) => ({
        ...state,
        Evaluation: "Pending",
      }));
    }
    if (shouldUseDashboardDateFallback && startDateId) {
      setTagnames((state) => ({
        ...state,
        "From Date": ddmmyyFormatter(startDateId),
      }));
    }
    if (shouldUseDashboardDateFallback && endDateId) {
      setTagnames((state) => ({
        ...state,
        "To Date": ddmmyyFormatter(endDateId),
      }));
    }
    if (isMtdBookingRedirect) {
      setTagnames((state) => ({
        ...state,
        Source: "MTD Booking",
      }));
    }
    if (isLiveBookingRedirect && liveBookingCategoryParam) {
      setTagnames((state) => ({
        ...state,
        Category:
          liveBookingCategoryParam.charAt(0).toUpperCase() +
          liveBookingCategoryParam.slice(1),
      }));
    }
    if ((hotKeyId || isMtdBookingRedirect) && modelIdParam) {
      const modelName = modalData
        ?.filter((ele) => ele.id === +modelIdParam)
        ?.at(0)?.model_name;
      if (modelName) {
        setTagnames((state) => ({
          ...state,
          Model: modelName,
        }));
      }
    }
    if (
      (hotKeyId || isDashboardTableRedirect) &&
      modelTypeArrayFromParams.length > 0
    ) {
      const modelNames = modelTypeArrayFromParams
        .map((modelId) => {
          const model = modalData?.filter((ele) => ele.id === +modelId)?.at(0);
          return model?.model_name;
        })
        .filter(Boolean);
      if (modelNames.length > 0) {
        setTagnames((state) => ({
          ...state,
          Model: modelNames.join(", "),
        }));
      }
    } else if (hotKeyId && modelType) {
      const model = modalData
        ?.filter((ele) => ele.id === +modelType)
        ?.at(0)?.model_name;
      setTagnames((state) => ({ ...state, Model: model }));
    }
    if (hotKeyId && exchangeStageNameParam) {
      setTagnames((state) => ({
        ...state,
        "Exchange Stage": exchangeStageNameParam,
      }));
    }
    if (hotKeyId && exchangeOfficerName) {
      setTagnames((state) => ({
        ...state,
        "Exchange Evaluation Team": exchangeOfficerName,
      }));
    }
    if (
      (hotKeyId || isDashboardTableRedirect) &&
      (areaIdsFromParams.length > 0 || areaIdParam)
    ) {
      const areas =
        areaIdsFromParams.length > 0
          ? areaIdsFromParams
              .map((id) => {
                const area = areaData?.find((a) => a.id === +id);
                return area?.name;
              })
              .filter(Boolean)
              .join(", ")
          : (() => {
              const area = areaData?.find((a) => a.id === +areaIdParam);
              return area?.name || "";
            })();
      if (areas) {
        setTagnames((state) => ({
          ...state,
          Area: areas,
        }));
      }
    }
    if (hotKeyId && (leadOwnedFromParams.length > 0 || leadOwnedParam)) {
      const owners =
        leadOwnedFromParams.length > 0
          ? leadOwnedFromParams
              .map((id) => {
                const owner = ownerData?.find((o) => o.id === +id);
                return owner?.full_name;
              })
              .filter(Boolean)
              .join(", ")
          : (() => {
              const owner = ownerData?.find((o) => o.id === +leadOwnedParam);
              return owner?.full_name || "";
            })();
      if (owners) {
        setTagnames((state) => ({
          ...state,
          "Lead Owner": owners,
        }));
      }
    }
    if (hotKeyId && leadOwnerName) {
      setTagnames((state) => ({
        ...state,
        "Lead Owner": leadOwnerName,
      }));
    }
    if (isLiveBookingRedirect && areaNameParam) {
      setTagnames((state) => ({
        ...state,
        Area: areaNameParam,
      }));
    }
    if (hotKeyId && isProcured) {
      setTagnames((state) => ({
        ...state,
        Status: "Procured",
      }));
    }
  }, [
    typeParamId,
    stageParamId,
    leadsTypeData,
    leadStageData,
    needProcurment,
    needEvaluation,
    areaData,
    ownerData,
    areaIdsFromParams,
    areaIdParam,
    leadOwnedFromParams,
    leadOwnedParam,
    isProcured,
  ]);

  const onSearch = (value) => {
    setFilters((prev) => ({
      ...prev,
      search: value,
      page: 1,
      dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
    }));
  };
  const getModalData = async () => {
    setIsLoading(true);
    try {
      const modalDataArray = await getVehicleModelService(1);
      setModalData(modalDataArray?.data?.data);
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };
  // Helper function to filter out false values
  const filterFalseValues = (data) => {
    const filtered = {};
    
    // Only include keys that are not false
    Object.keys(data).forEach((key) => {
      // Keep all values except false booleans
      if (data[key] !== false) {
        filtered[key] = data[key];
      }
    });

    return filtered;
  };

  const getExchangeLeadListing = async (data) => {
    setIsLoading(true);
    try {
      const filteredData = filterFalseValues(data);
      await dispatch(fetchExchangeLeadList(filteredData));
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getLeadsTypeData = async () => {
    setIsLoading(true);
    try {
      const leadsDataArray = await getLeadService();
      setLeadsTypeData(leadsDataArray?.data?.data);
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getLeadStagesData = async () => {
    setIsLoading(true);
    try {
      const stateData = await getLeadStagesService();
      setLeadStageData(stateData?.data?.data);
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getExchangeStagesData = async () => {
    try {
      const response = await getLeadExchangeStageService();
      if (response?.data?.status === API_RESPONSE_CODES?.OK) {
        setExchangeStages(response?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching exchange stages:", error);
    }
  };

  const getFileStagesData = async () => {
    setIsLoading(true);
    try {
      const response = await getFileStagesService();
      if (response?.status === API_RESPONSE_CODES?.OK) {
        setFileStageData(response?.data?.data || []);
      }
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Helper function to check if user should see Unallocated option
  const shouldShowUnallocated = () => {
    const salesTeamRoles = [
      "Super Admin",
      "CEO",
      "VP Sales",
      "GM (General Manager)",
      "AGM (Assistant General Manager)",
      "TSM (Territory Sales Manager)",
      "Sales Manager",
      "Team Leader",
      "Sales Officer",
    ];
    return salesTeamRoles.includes(roleType);
  };

  // Handler for Exchange Stages dropdown - uses state instead of URL navigation
  const handleExchangeStageChange = (value) => {
    // Update state
    setExchangeStageFilter(value);

    // Update filters state
    if (!value || value === "all_leads") {
      // Clear exchange stage filters
      setFilters((prev) => ({
        ...prev,
        page: 1,
        lead_exchange_stage_id: null,
        approval_pending_for_final_inspection: null,
        last_month: false,
        current_month: false,
        dashboard_redirect: false,
      }));
    } else if (value === "pending_eval_prev_month") {
      setFilters((prev) => ({
        ...prev,
        page: 1,
        lead_exchange_stage_id: "1",
        approval_pending_for_final_inspection: null,
        last_month: true,
        current_month: false,
        dashboard_redirect: false,
      }));
    } else if (value === "pending_eval_current_month") {
      setFilters((prev) => ({
        ...prev,
        page: 1,
        lead_exchange_stage_id: "1",
        approval_pending_for_final_inspection: null,
        last_month: false,
        current_month: true,
        dashboard_redirect: false,
      }));
    } else if (value === "un_allocated") {
      setFilters((prev) => ({
        ...prev,
        page: 1,
        lead_exchange_stage_id: null,
        approval_pending_for_final_inspection: null,
        last_month: false,
        current_month: false,
        dashboard_redirect: false,
      }));
    } else if (value === "awaiting_inspection") {
      setFilters((prev) => ({
        ...prev,
        page: 1,
        lead_exchange_stage_id: null,
        approval_pending_for_final_inspection: 1,
        last_month: false,
        current_month: false,
        dashboard_redirect: false,
      }));
    } else if (value && value.startsWith("stage_")) {
      const stageId = value.replace("stage_", "");
      setFilters((prev) => ({
        ...prev,
        page: 1,
        lead_exchange_stage_id: stageId,
        approval_pending_for_final_inspection: null,
        last_month: false,
        current_month: false,
        dashboard_redirect: false,
      }));
    }
  };

  const routeCheck = isAdmin ? "/admin" : "";

  const handleButtonClick = () => {
    navigate(`${routeCheck}/leads/exchange-lead`);
    setFilters({
      page: 1,
      per_page: 10,
      search: "",
      procured: false,
      evaluation_completed: false,
      lead_stage: [],
      lead_type: [],
      lead_exchange_stage_id: null,
      need_evaluation: false,
      need_procured: false,
      approval_pending_for_final_inspection: null,
      last_month: false,
      start_date: null,
      end_date: null,
      model_type: [],
      territory_id: [],
      area_id: [],
      lead_owned: [],
      current_month: false,
      allocation_status: null,
      file_stage_id: null,
      dashboard_redirect: false,
      live_booking_redirect: false,
      live_booking_category: "",
      mtd_booking_redirect: false,
    });
  };

  const getOwnerData = async () => {
    setIsLoading(true);
    try {
      const ownerData = await getLeadOwnerService();
      if (ownerData?.status === API_RESPONSE_CODES?.OK) {
        setOwnerData(ownerData?.data?.data);
      }
    } catch (error) {
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getTerritoryData = async () => {
    setIsLoading(true);
    try {
      const territoryData = await getFilterTerritoriesService();
      if (territoryData?.status === API_RESPONSE_CODES?.OK) {
        setTerritoryData(territoryData?.data?.data);
      }
    } catch (error) {
      setTerritoryData([]);
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getAreaData = async () => {
    setIsLoading(true);
    try {
      const areaData = await getFilterAreaService();
      if (areaData?.status === API_RESPONSE_CODES?.OK) {
        setAreaData(areaData?.data?.data);
      }
    } catch (error) {
      setAreaData([]);
      notification.error({
        description: error.response?.data?.message ?? error?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleTerritoryChange = (value) => {
    setFilters((state) => ({
      ...state,
      page: 1,
      territory_id: value,
      dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
    }));

    setRegister((state) => ({
      ...state,
      territory_id: value,
    }));
    getAreaData(register.state_id, value);
  };

  const handlePageChange = (page, pageSize) => {
    setFilters((state) => ({
      ...state,
      page: page,
      per_page: pageSize,
    }));
  };

  const handleViewLead = (leadId) => {
    openLeadViewInNewWindow(isAdmin, leadId);
  };

  const handleDecision = async (leadId, decision) => {
    try {
      const payload = {
        lead_id: leadId,
        inspection_officer_decision: decision,
      };
      const res = await approveRejectFinalInspectionService(payload);
      notification.success({ message: res?.data?.message });
      dispatch(fetchLeadDetailsServices({ id: leadId }));
      getExchangeLeadListing(filters);
    } catch (error) {
      notification.error({
        description: error?.response?.data?.message ?? error?.message,
      });
    }
  };

  // Table columns definition
  const getTableColumns = () => {
    const awaitingInspectionTab =
      exchangeStageFilter === "awaiting_inspection" ||
      filters?.approval_pending_for_final_inspection === 1;

    // Determine color based on status
    const getStatusColor = (status) => {
      const statusLower = status?.toLowerCase();
      if (statusLower === "open") {
        return "gold"; // Yellow
      } else if (statusLower === "converted") {
        return "green";
      } else if (statusLower === "lost" || statusLower === "dropped") {
        return "red";
      } else if (statusLower === "refunded" || statusLower === "cancelled") {
        return "orange";
      }
      return "default"; // Default color for other statuses
    };

    const columns = [
      {
        title: "Lead Type",
        dataIndex: ["lead_type", "name"],
        key: "lead_type",
        width: 120,
        render: (text) => text || "-",
      },
      {
        title: "Lead No.",
        dataIndex: "id",
        key: "lead_no",
        width: 150,
        render: (text, record) => (
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            <span
              onClick={(e) => {
                e.stopPropagation();
                handleViewLead(record?.id);
              }}
              style={{
                cursor: "pointer",
                color: "#1890ff",
                textDecoration: "underline",
              }}
            >
              {text}
            </span>
            {record?.exchange_car === "Yes" && (
              <Tag color="gold" size="small" style={{ width: "fit-content" }}>
                Exchange Car
              </Tag>
            )}
          </div>
        ),
      },
      {
        title: "Lead Stage",
        dataIndex: ["lead_stage", "name"],
        key: "lead_stage",
        width: 120,
        render: (text) => text || "-",
      },
      {
        title: "Vehicle",
        key: "vehicle",
        width: 200,
        render: (_, record) => {
          const model = record?.vehicle_detail?.model?.model_name || "";
          const fuel = record?.vehicle_detail?.fuel_type?.title || "";
          const color = record?.vehicle_detail?.color?.color || "";
          return (
            `${model}${fuel ? `: ${fuel}` : ""}${color ? `: ${color}` : ""}` ||
            "-"
          );
        },
      },
      {
        title: "Customer",
        key: "customer",
        width: 180,
        render: (_, record) => {
          const name = record?.customer?.full_name || "";
          const phone = record?.customer?.phone_no || "";
          return name && phone ? `${name}, ${phone}` : name || phone || "-";
        },
      },
      {
        title: "Address",
        dataIndex: ["customer", "address"],
        key: "address",
        width: 200,
        render: (text) => text || "-",
      },
      {
        title: "Added On",
        dataIndex: "created_at",
        key: "added_on",
        width: 120,
        render: (text) => (text ? ddmmyyFormatter(text) : "-"),
      },
      {
        title: "Next Follow Up",
        dataIndex: "next_follow_up_date",
        key: "next_follow_up",
        width: 140,
        render: (text) => (text ? ddmmyyFormatter(text) : "-"),
      },
      {
        title: "Status",
        dataIndex: ["lead_status", "name"],
        key: "status",
        width: 120,
        render: (text, record) => {
          const isLeadDroppedOrLost =
            record?.lead_status_id === 2 || record?.lead_status_id === 3;
          const statusName = text || "-";
          const statusLower = statusName?.toLowerCase();
          const statusColor = getStatusColor(statusName);

          // Show tooltip for lost, dropped, cancelled, or refunded status with remarks
          const shouldShowTooltip =
            (isLeadDroppedOrLost ||
              statusLower === "cancelled" ||
              statusLower === "refunded") &&
            record?.lead_status_remark_detail?.reason_detail?.length > 0;

          if (shouldShowTooltip) {
            return (
              <Tooltip
                title={
                  <ul style={{ margin: 0, paddingLeft: 20 }}>
                    {record.lead_status_remark_detail.reason_detail.map(
                      (ele, index) => (
                        <li key={index}>{ele}</li>
                      )
                    )}
                  </ul>
                }
              >
                <Tag color={statusColor}>{statusName}</Tag>
              </Tooltip>
            );
          }
          return <Tag color={statusColor}>{statusName}</Tag>;
        },
      },
      {
        title: "Allocation Status",
        dataIndex: "allocation_status",
        key: "allocation_status",
        width: 180,
        render: (text) => {
          if (!text || text === null || text === undefined) {
            return "-";
          }
          // Determine color based on allocation status
          const getAllocationStatusColor = (status) => {
            const statusLower = status?.toLowerCase();
            if (statusLower === "allocated" || statusLower === "approved") {
              return "green";
            } else if (
              statusLower === "pending" ||
              statusLower === "in progress"
            ) {
              return "gold";
            } else if (
              statusLower === "rejected" ||
              statusLower === "cancelled"
            ) {
              return "red";
            }
            return "default";
          };
          const statusColor = getAllocationStatusColor(text);
          return <Tag color={statusColor}>{text}</Tag>;
        },
      },
      {
        title: "Action",
        key: "action",
        width: 200,
        fixed: "right",
        render: (_, record) => {
          const showApprovalButtons =
            record?.awaiting_inspection_status === true &&
            record?.exchange_vehicle_detail?.inspection_officer_decision === 0;
          const isEvaluated =
            record?.exchange_vehicle_detail?.is_evaluated === 1;

          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "2px",
                flexWrap: "nowrap",
              }}
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
            >
              <Button
                type="text"
                size="small"
                icon={<EyeFilled />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleViewLead(record?.id);
                }}
                style={{ pointerEvents: "auto" }}
              />
              {showApprovalButtons && (
                <>
                  <Button
                    size="small"
                    type="primary"
                    style={{
                      backgroundColor: "#0a9551",
                      borderColor: "#0a9551",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDecision(record?.id, 1);
                    }}
                  >
                    Approve
                  </Button>
                  <Button
                    size="small"
                    danger
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDecision(record?.id, 2);
                    }}
                  >
                    Reject
                  </Button>
                </>
              )}
              {/* <Button
                type='text'
                size='small'
                icon={<WhatsAppOutlined />}
                onClick={(e) => {
                  e.stopPropagation();
                  // TODO: Add WhatsApp functionality
                }}
                style={{ pointerEvents: 'auto' }}
              />
              <Button
                type='text'
                size='small'
                icon={<PhoneOutlined />}
                onClick={(e) => {
                  e.stopPropagation();
                  // TODO: Add Phone functionality
                }}
                style={{ pointerEvents: 'auto' }}
              />
              <Button
                type='text'
                size='small'
                icon={<MailOutlined />}
                onClick={(e) => {
                  e.stopPropagation();
                  // TODO: Add Email functionality
                }}
                style={{ pointerEvents: 'auto' }}
              />
              <Button
                type='text'
                size='small'
                icon={<MessageOutlined />}
                onClick={(e) => {
                  e.stopPropagation();
                  // TODO: Add Message functionality
                }}
                style={{ pointerEvents: 'auto' }}
              /> */}
              {/* {!isEvaluated && (
                <Badge count='Evaluation' color='#ff4d4f' style={{ marginLeft: '4px' }} />
              )} */}
            </div>
          );
        },
      },
    ];

    return columns;
  };

  return (
    <>
      <Loader loading={isLoading} />
      <div className="user-data">
        <div className="user-left justify-content-between d-flex align-items-center">
          <Title level={4} className="">
            My Leads
          </Title>
        </div>

        {showRedirectTags ? (
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
            <Space size={"middle"} wrap>
              {Object.entries(tagNames)?.map(([key, value]) => (
                <Space key={key}>
                  {/* Adding a key for each pair for React's rendering */}
                  <span className="tag-label">{key}:</span>
                  <Tag color="green">{value}</Tag>
                </Space>
              ))}
            </Space>

            <Button
              type="primary"
              className="secondary-button"
              onClick={handleButtonClick}
            >
              Go to Leads List
            </Button>
          </div>
        ) : (
          <>
            <div className="search-leads pb-4"></div>
            {/* <Radio.Group onChange={handleChange} value={radioData}>
              <Radio value={'all'}>All</Radio>
              <Radio value={'need_evaluation'}>Evaluation Needed</Radio>
              <Radio value={'evaluation_completed'}>Evaluation Completed</Radio>
              <Radio value={'need_procured'}>Procurement Needed</Radio>
              <Radio value={'procured'}>Procured</Radio>
            </Radio.Group> */}
            <Card>
              <Row className="mt-3" gutter={[16, 16]}>
                <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                  <Search
                    allowClear
                    value={filters.search}
                    onChange={(e) =>
                      setFilters((prev) => ({
                        ...prev,
                        search: e.target.value,
                        dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
                      }))
                    }
                    onSearch={onSearch}
                    placeholder="Search by Customer and Contact Number"
                  />
                </Col>
                <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                  <RangePicker
                    format="DD/MM/YYYY"
                    className="form-control-ant"
                    value={
                      filters?.start_date && filters?.end_date
                        ? [dayjs(filters.start_date), dayjs(filters.end_date)]
                        : null
                    }
                    onChange={(dates) =>
                      setFilters((state) => ({
                        ...state,
                        page: 1,
                        start_date:
                          dates && dates[0] ? dates[0].format("YYYY-MM-DD") : null,
                        end_date:
                          dates && dates[1] ? dates[1].format("YYYY-MM-DD") : null,
                        dashboard_redirect: false,
                      }))
                    }
                  />
                </Col>
                <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                  <Select
                    allowClear
                    mode="multiple"
                    maxTagCount={2}
                    placeholder="Lead Type"
                    className="form-control-ant"
                    value={filters.lead_type}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(ele) =>
                      setFilters((state) => ({
                        ...state,
                        page: 1,
                        lead_type: ele,
                        dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
                      }))
                    }
                  >
                    {leadsTypeData?.map((option) => (
                      <Select.Option key={option.id} value={option.id}>
                        {option.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>

                <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                  <Select
                    allowClear
                    mode="multiple"
                    maxTagCount={2}
                    placeholder="Lead Stage"
                    value={filters.lead_stage}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    className="form-control-ant"
                    onChange={(ele) =>
                      setFilters((state) => ({
                        ...state,
                        page: 1,
                        lead_stage: ele,
                        dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
                      }))
                    }
                  >
                    {leadStageData?.map((option) => (
                      <Select.Option key={option.id} value={option.id}>
                        {option?.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>

                <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                  <Select
                    allowClear
                    mode="multiple"
                    maxTagCount={2} // {/*
                    placeholder="Model Type"
                    className="form-control-ant"
                    value={filters.model_type}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(ele) =>
                      setFilters((state) => ({
                        ...state,
                        page: 1,
                        model_type: ele,
                        dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
                      }))
                    }
                  >
                    {modalData?.map((option) => (
                      <Select.Option key={option.id} value={option.id}>
                        {option?.model_name}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>
                <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                  <Select
                    allowClear
                    mode="multiple"
                    maxTagCount={2}
                    placeholder="Territory"
                    className="form-control-ant"
                    value={filters.territory_id}
                    onChange={handleTerritoryChange}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {territoryData?.map((option) => (
                      <Select.Option key={option.id} value={option.id}>
                        {option?.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>

                <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                  <Select
                    allowClear
                    mode="multiple"
                    maxTagCount={2}
                    placeholder="Area"
                    className="form-control-ant"
                    value={filters.area_id}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(ele) =>
                      setFilters((state) => ({
                        ...state,
                        page: 1,
                        area_id: ele,
                        dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
                      }))
                    }
                  >
                    {areaData?.map((option) => (
                      <Select.Option key={option.id} value={option.id}>
                        {option?.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>

                {/* <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                <Select
                  allowClear
                  mode='multiple'
                  maxTagCount={2}
                  placeholder='Lead Owner'
                  className='form-control-ant'
                  filterOption={(input, option) =>
                    option.children?.join(' ')?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
                  }
                  onChange={(ele) =>
                    setFilters((state) => ({
                      ...state,
                      page: 1,
                      lead_owned: ele,
                    }))
                  }
                >
                  {ownerData?.map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                      {option?.full_name}
                      {option?.title ? ` (${option?.title})` : ''}
                    </Select.Option>
                  ))}
                </Select>
              </Col> */}
                <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                  <Select
                    allowClear
                    placeholder="Allocation Status"
                    className="form-control-ant"
                    value={filters.allocation_status}
                    onChange={(ele) =>
                      setFilters((state) => ({
                        ...state,
                        page: 1,
                        allocation_status: ele,
                        dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
                      }))
                    }
                  >
                    <Select.Option value={0}>
                      No Allocation Requests
                    </Select.Option>
                    <Select.Option value={1}>Request Pending</Select.Option>
                    <Select.Option value={2}>Approved</Select.Option>
                    <Select.Option value={3}>Rejected</Select.Option>
                    <Select.Option value={4}>
                      Cancellation Requested
                    </Select.Option>
                    <Select.Option value={5}>
                      Cancellation Approved
                    </Select.Option>
                  </Select>
                </Col>
                <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                  <Select
                    allowClear
                    placeholder="Exchange Stages"
                    className="form-control-ant"
                    value={exchangeStageFilter}
                    onChange={handleExchangeStageChange}
                  >
                    <Select.Option value="pending_eval_prev_month">
                      Pending for Evaluation (Prev Month)
                    </Select.Option>
                    <Select.Option value="pending_eval_current_month">
                      Pending for Evaluation (Current Month)
                    </Select.Option>
                    {exchangeStages
                      .filter((stage) => stage.id !== 1)
                      .map((stage) => (
                        <Select.Option
                          key={stage.id}
                          value={`stage_${stage.id}`}
                        >
                          {stage.name}
                        </Select.Option>
                      ))}
                    {shouldShowUnallocated() && (
                      <Select.Option value="un_allocated">
                        Unallocated
                      </Select.Option>
                    )}
                    {(roleType === "Exchange Evaluation Team" ||
                      roleType === "Procurement Manager" ||
                      roleType === "Super Admin") && (
                      <Select.Option value="awaiting_inspection">
                        Awaiting Inspection Approvals
                      </Select.Option>
                    )}
                  </Select>
                </Col>
                <Col xl={4} lg={6} md={6} sm={24} xs={24}>
                  <Select
                    allowClear
                    placeholder="File Stage"
                    className="form-control-ant"
                    value={filters.file_stage_id}
                    onChange={(ele) =>
                      setFilters((state) => ({
                        ...state,
                        page: 1,
                        file_stage_id: ele,
                        dashboard_redirect: false, // Filter changes on page should not pass dashboard_redirect
                      }))
                    }
                  >
                    {fileStageData?.map((option) => (
                      <Select.Option key={option.id} value={option.id}>
                        {option?.stage_name}
                      </Select.Option>
                    ))}
                  </Select>
                </Col>
              </Row>
            </Card>
          </>
        )}
        <div className="lead-type-card pt-4">
          <Table
            columns={getTableColumns()}
            dataSource={
              hasExchangeLeadsData
                ? exchangeLeads?.map((item) => ({ ...item, key: item.id }))
                : []
            }
            loading={isLoading}
            pagination={{
              current: filters?.page,
              total: exchangeLeadsData?.total_records || 0,
              pageSize: filters?.per_page,
              showSizeChanger: true,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} leads`,
              onChange: (page, pageSize) => handlePageChange(page, pageSize),
              onShowSizeChange: (current, size) =>
                handlePageChange(current, size),
            }}
            locale={{
              emptyText: <NoDataFound />,
            }}
            scroll={{
              x: "max-content", // 🟢 makes it responsive horizontally
            }}
          />
        </div>
      </div>
    </>
  );
};

export default ExchangeLeads;
